import { I18N_BASE } from '../constants';

export interface BlockConfirmLabel {
  i18nKey: string;
  params: { count: number };
}

export function getBlockConfirmLabel(selectedCount: number): BlockConfirmLabel {
  const count = Math.max(1, selectedCount);
  const key =
    count === 1
      ? `${I18N_BASE}.blockModal.confirm.singular`
      : `${I18N_BASE}.blockModal.confirm.plural`;
  return { i18nKey: key, params: { count } };
}
